module.exports = __webpack_public_path__ + "files/2561f94b6dfb1a80c0c9e74f92cc1d64.png";